import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { InventoryStockTransferDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/InventoryStockTransfers/inventory-stock-transfer-dto';
import { StockTransferLineItemDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/InventoryStockTake/stock-transfer-line-item-dto';
import { InventoryService } from 'src/api/generated/services';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';
import { GetStockTransfer$Params } from 'src/api/generated/fn/inventory/get-stock-transfer';
import { Subscription } from 'rxjs';
import { InventoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';
import { GetInventory$Params } from 'src/api/generated/fn/inventory/get-inventory';

@Component({
  selector: 'app-incoming-transfer-details',
  templateUrl: './incoming-transfer-details.component.html',
  styleUrls: ['./incoming-transfer-details.component.scss']
})
export class IncomingTransferDetailsComponent implements OnInit, OnDestroy {

  venueId: string;
  inventoryId: string;
  transferId: string;
  inventory: InventoryDto;

  public transfer: InventoryStockTransferDto = {} as InventoryStockTransferDto;
  public selectedItems: Array<StockTransferLineItemDto> = new Array<StockTransferLineItemDto>();
  venueIdUpdateSubscription: Subscription;

  constructor(
              private inventoryService: InventoryService,
              private route: ActivatedRoute,
              private router: Router,
              private currentVenueHelper: CurrentVenueHelperService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['venue-id'] != null) {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
      }
      if (params['inventory-id'] != null && params['transfer-id'] != null) {
        this.inventoryId = params['inventory-id'];
        this.transferId = params['transfer-id'];

        const inventoryParams: GetInventory$Params = { inventoryId: this.inventoryId };
        this.inventoryService.getInventory(inventoryParams).subscribe(response => this.inventory = response);
        
        const transferParams: GetStockTransfer$Params = { inventoryId: this.inventoryId, transferId: this.transferId };
        this.inventoryService.getStockTransfer(transferParams).subscribe(response => {
          this.transfer = response;
          this.selectedItems = this.transfer.lineItems ? this.transfer.lineItems?.filter(item => item.quantityReceived != null ) : [];
        });
      }
    });

  }

  navigateToMain() {
    if(this.inventory.isMain){
      this.router.navigate([this.venueId, "inventory", this.inventoryId], { queryParams: { activeIndex: 3 }}); 
    }else{
      this.router.navigate([this.venueId, "inventory", this.inventoryId], { queryParams: { activeIndex: 2 }}); 
    }
  }

  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }

}
